import React from 'react'
import { connect } from 'react-redux'
import { DynamicModuleLoader } from 'redux-dynamic-modules'
import { Route } from 'react-router-dom'
import Loadable from 'react-loadable'
import modules, { init, clearTimeOut } from './modules'
import Loading from 'components/Loading'
import { languageChange } from 'store/siteConfig'

export default function(route) {
  const Details = Loadable({
    loader: () => import('./Details'),
    render(loaded, props) {
      const Component = connect(
        state => ({
          couponDetailsState: state.couponDetailsState,
          siteConfig: state.siteConfig
        }),
        {
          init,
          languageChange,
          clearTimeOut
        }
      )(loaded.default)
      return <Component {...props} />
    },
    loading: Loading
  })

  return (
    <Route
      path={`${route.match.path}/details/:couponId`}
      render={routeProps => (
        <DynamicModuleLoader modules={[modules(routeProps.history)]}>
          <Details {...routeProps} />
        </DynamicModuleLoader>
      )}
    />
  )
}
